// @ts-nocheck
/* eslint-disable */

"use client";

import { RichText } from "politicamente-informados-ds";
import classNames from "classnames";
import getBlockStyles from "@/lib/wordpress/blocks/getBlockStyles";

export type IBlockParagraph = {
  attrs: {
    align?: any;
    anchor?: string;
    backgroundColorHex?: string;
    content?: string;
    maxWidth?: string;
    textColor?: string;
    textColorHex?: string;
    className?: string;
    style?: Record<string, unknown>;
    animation?: string;
  };
};

export default function BlockParagraph({ attrs }: IBlockParagraph) {
  const {
    align,
    anchor,
    backgroundColorHex,
    className,
    content,
    style,
    textColor,
    textColorHex,
    animation,
  } = attrs || {};

  const paragraphStyle = getBlockStyles({
    backgroundColor: backgroundColorHex,
    textColor: textColor || textColorHex,
    textAlign: align,
    style,
  });

  return (
    <RichText
      id={anchor || undefined}
      tag="p"
      className={classNames(
        className,
        animation && `elements_animated ${animation}`
      )}
      style={{
        ...paragraphStyle,
      }}
    >
      {content}
    </RichText>
  );
}
